import { Fmt, FmtColored } from '../../widgets/format'
import { useWidgetContext } from '../../widgets/providers'
import { Typography } from '../../common/typography'
import classes from './YearCard.module.css'

export default function YearCard({
  title,
  target,
  actual,
  percent,
  achieved,
  achievedTeams,
}: {
  title: string
  target: number
  actual: number
  percent: number
  achieved: string
  achievedTeams: string
}) {
  const ctx = useWidgetContext()
  const metric = ctx.metric || ''

  return (
    <div className={classes.container}>
      <Typography fw={500} lh="100">
        {title}
      </Typography>
      <div className={classes.row}>
        <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
          Target
        </Typography>
        <Typography
          ff="JetBrains Mono"
          fc={{ light: 'gray-7', dark: 'gray-3' }}
          ta="right"
          lh="140"
        >
          <Fmt
            metric={metric}
            component="target"
            statistic="value"
            value={target}
          />
        </Typography>
      </div>

      <div className={classes.row}>
        <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
          Actual
        </Typography>
        <Typography
          ff="JetBrains Mono"
          fc={{ light: 'gray-7', dark: 'gray-3' }}
          ta="right"
          lh="140"
        >
          <Fmt
            metric={metric}
            component="actual"
            statistic="value"
            value={actual}
          />
        </Typography>
      </div>

      <div className={classes.row}>
        <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
          Ach%
        </Typography>
        <Typography
          ff="JetBrains Mono"
          fc={{ light: 'gray-7', dark: 'gray-3' }}
          ta="right"
          lh="140"
        >
          <FmtColored
            metric={metric}
            component="percent"
            statistic="value"
            value={percent}
          />
        </Typography>
      </div>

      <div className={classes.row}>
        <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
          Players
        </Typography>
        <Typography
          ff="JetBrains Mono"
          fc={{ light: 'primary-5', dark: 'primary-4' }}
          ta="right"
          lh="140"
          className={classes.team}
        >
          {ctx.subject_type !== 'overall' ? '-' : achieved}
        </Typography>
      </div>

      <div className={classes.row}>
        <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
          Teams
        </Typography>
        <Typography
          ff="JetBrains Mono"
          fc={{ light: 'primary-5', dark: 'primary-4' }}
          ta="right"
          lh="140"
          className={classes.team}
        >
          {ctx.subject_type !== 'overall' ? '-' : achievedTeams}
        </Typography>
      </div>
    </div>
  )
}
